import { render, staticRenderFns } from "./PayoutDetailsList.vue?vue&type=template&id=584c1aca&"
import script from "./PayoutDetailsList.vue?vue&type=script&lang=js&"
export * from "./PayoutDetailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports